<template>
  <div class="animalGermplasm">
    <div class="animalGermplasm-lg">
      <el-descriptions class="margin-top" style="text-align: center" :title="this.title + '详情'" :column="3" border>

<!--        <el-descriptions-item label="属中文名" prop="belongChinese">-->
<!--          {{ infoContent.belongChinese }}-->
<!--        </el-descriptions-item>-->
<!--        <el-descriptions-item label="属拉丁名" prop="belongLatin">-->
<!--          {{ infoContent.belongLatin }}-->
<!--        </el-descriptions-item>-->
        <el-descriptions-item label="种中文名" prop="growChinese">
          {{ infoContent.growChinese }}
        </el-descriptions-item>
        <el-descriptions-item label="种拉丁名" prop="growLatin">
          {{ infoContent.growLatin }}
        </el-descriptions-item>
        <el-descriptions-item label="科中文名" prop="sectionChinese">
          {{ infoContent.sectionChinese }}
        </el-descriptions-item>
        <el-descriptions-item label="科拉丁名" prop="sectionLatin">
          {{ infoContent.sectionLatin }}
        </el-descriptions-item>
<!--        <el-descriptions-item label="品种/种群" prop="varietalPopulation">-->
<!--          {{ infoContent.varietalPopulation }}-->
<!--        </el-descriptions-item>-->
        <el-descriptions-item label="资源类型" prop="resourceType">
          {{ infoContent.resourceType }}
        </el-descriptions-item>
        <el-descriptions-item label="采集号" prop="collectNumber">
          {{ infoContent.collectNumber }}
        </el-descriptions-item>
        <el-descriptions-item label="库号" prop="libNum">
          {{ infoContent.libNum }}
        </el-descriptions-item>
        <el-descriptions-item label="采集人" prop="collectUser">
          {{ infoContent.collectUser }}
        </el-descriptions-item>
<!--        <el-descriptions-item label="采集日期" prop="collectTime">-->
<!--          {{ infoContent.collectTime }}-->
<!--        </el-descriptions-item>-->
        <el-descriptions-item label="采集年份" prop="collectYear">
          {{ infoContent.collectYear }}
        </el-descriptions-item>
        <el-descriptions-item label="省" prop="province">
          {{ infoContent.province }}
        </el-descriptions-item>
        <el-descriptions-item label="地区" prop="area">
          {{ infoContent.area }}
        </el-descriptions-item>
        <el-descriptions-item label="单位" prop="sampleUnit">
          {{ infoContent.sampleUnit }}
        </el-descriptions-item>
        <el-descriptions-item label="专题负责人" prop="specialLeader">
          {{ infoContent.specialLeader }}
        </el-descriptions-item>
        <el-descriptions-item label="发布时间" prop="createTime">
          {{ infoContent.createTime }}
        </el-descriptions-item>
<!--        <el-descriptions-item v-if="infoContent.pictureVideoFileList.length > 0" label="图片展示" span="3"  class="img">-->
<!--          &lt;!&ndash;         <template slot-scope="scope">&ndash;&gt;-->
<!--          <el-carousel :interval="2000" arrow="always" class="carousel">-->
<!--            <el-carousel-item v-for="item in infoContent.pictureVideoFileList"-->
<!--                              :key="item.id">-->
<!--              <img :src="item.url" alt="" class="carousel-img">-->
<!--            </el-carousel-item>-->
<!--          </el-carousel>-->

<!--        </el-descriptions-item>-->
  </el-descriptions>
    </div>
    <div class="animalGermplasm-sm">
      <el-descriptions class="margin-top" style="text-align: center" :title="this.title + '详情'" :column="3" border>

<!--        <el-descriptions-item label="属中文名" prop="belongChinese">-->
<!--          {{ infoContent.belongChinese }}-->
<!--        </el-descriptions-item>-->
<!--        <el-descriptions-item label="属拉丁名" prop="belongLatin">-->
<!--          {{ infoContent.belongLatin }}-->
<!--        </el-descriptions-item>-->
        <el-descriptions-item label="种中文名" prop="growChinese">
          {{ infoContent.growChinese }}
        </el-descriptions-item>
        <el-descriptions-item label="种拉丁名" prop="growLatin">
          {{ infoContent.growLatin }}
        </el-descriptions-item>
        <el-descriptions-item label="科中文名" prop="sectionChinese">
          {{ infoContent.sectionChinese }}
        </el-descriptions-item>
        <el-descriptions-item label="科拉丁名" prop="sectionLatin">
          {{ infoContent.sectionLatin }}
        </el-descriptions-item>
<!--        <el-descriptions-item label="品种/种群" prop="varietalPopulation">-->
<!--          {{ infoContent.varietalPopulation }}-->
<!--        </el-descriptions-item>-->
        <el-descriptions-item label="资源类型" prop="resourceType">
          {{ infoContent.resourceType }}
        </el-descriptions-item>
        <el-descriptions-item label="采集号" prop="collectNumber">
          {{ infoContent.collectNumber }}
        </el-descriptions-item>
        <el-descriptions-item label="库号" prop="libNum">
          {{ infoContent.libNum }}
        </el-descriptions-item>
        <el-descriptions-item label="采集人" prop="collectUser">
          {{ infoContent.collectUser }}
        </el-descriptions-item>
<!--        <el-descriptions-item label="采集日期" prop="collectTime">-->
<!--          {{ infoContent.collectTime }}-->
<!--        </el-descriptions-item>-->
        <el-descriptions-item label="采集年份" prop="collectYear">
          {{ infoContent.collectYear }}
        </el-descriptions-item>
        <el-descriptions-item label="省" prop="province">
          {{ infoContent.province }}
        </el-descriptions-item>
        <el-descriptions-item label="地区" prop="area">
          {{ infoContent.area }}
        </el-descriptions-item>
        <el-descriptions-item label="单位" prop="sampleUnit">
          {{ infoContent.sampleUnit }}
        </el-descriptions-item>
        <el-descriptions-item label="专题负责人" prop="specialLeader">
          {{ infoContent.specialLeader }}
        </el-descriptions-item>
        <el-descriptions-item label="发布时间" prop="createTime">
        {{ infoContent.createTime }}
        </el-descriptions-item>
<!--        <el-descriptions-item v-if="infoContent.pictureVideoFileList.length > 0" label="图片展示" span="3"  class="img">-->
<!--          <el-carousel :interval="2000" arrow="always" class="carousel">-->
<!--            <el-carousel-item v-for="item in infoContent.pictureVideoFileList"-->
<!--                              :key="item.id">-->
<!--              <img :src="item.url" alt="" class="carousel-img">-->
<!--            </el-carousel-item>-->
<!--          </el-carousel>-->
<!--        </el-descriptions-item>-->
      </el-descriptions>
    </div>
  </div>
</template>

<script>
export default {
  name: "animalGermplasm",
  props: {
    infoContent: Object,
    title: String
  },
}
</script>

<style scoped lang="scss">
.animalGermplasm{
  min-height: 500px;
  .animalGermplasm-lg{
    display: block;
  }
  .animalGermplasm-sm{
    display: none;
  }
}
::v-deep .el-descriptions__body .el-descriptions__table .el-descriptions-item__cell {
  text-align: center;
}
@media screen and (max-width: 576px) {
  .animalGermplasm {
    .animalGermplasm-lg {
      display: none;
    }
    .animalGermplasm-sm {
      display: block;
      .carousel {
        width: 99%;
        height: 80%;
        .carousel-img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
}

</style>